import * as React from 'react';
import './account/MyAccount.css';
import MyAccountTile from './MyAccountTile';
import homepage from './img/homepage.svg';
import realEstate from './img/real-estate.svg';
import MyAccountUserTile from './MyAccountUserTile';
import discount from './img/001-discount.svg';
import dollar from './img/dollar.svg';
import UserContactDetails from './UserContactDetails';
import UserAddressDetails from './UserAddressDetails';
import Customer from '../domain/Customer';

interface Props {
    title: string;
    customer: Customer;
    isAdmin: boolean;
}

class UserDetails extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <div className="card-container">
                <div className="my-account-container">
                    <MyAccountUserTile
                        isAdmin={this.props.isAdmin}
                        header={this.props.customer.name}
                        content={this.renderContactInfo(this.props.customer)}
                    />
                    <div className="my-account-addresses-container">
                        {this.props.customer.billingAddress && (
                            <MyAccountTile
                                header="BILLING ADDRESS"
                                image={realEstate}
                                content={<UserAddressDetails address={this.props.customer.billingAddress} />}
                            />
                        )}
                        {this.props.customer.shippingAddress && (
                            <MyAccountTile
                                header="SHIPPING ADDRESS"
                                image={homepage}
                                content={<UserAddressDetails address={this.props.customer.shippingAddress} />}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }

    private renderContactInfo = (info: Customer): JSX.Element => (
        <>
            <UserContactDetails name={info.name} email={info.email} customerNumber={info.customerId} />
            {info.shippingMethod && (
                <div className="client-dap">
                    Shipping method: <span className="client-dap-method">{info.shippingMethod}</span>
                </div>
            )}
            <div className="user-info">
                {this.renderPercents(discount, 'discount', info.discountRate)}
                {this.renderPercents(dollar, 'liability', info.liabilityRate)}
            </div>
        </>
    );

    private renderPercents = (image: string, label: string, value: number): JSX.Element => (
        <div className="user-info-container">
            <div className="info-img-wrapper">
                <img src={image} alt="user-info" />
            </div>
            <div className="user-percent-container">
                <span className="value">{value}%</span>
                <span className="description">{label}</span>
            </div>
        </div>
    );
}

export default UserDetails;



// WEBPACK FOOTER //
// ./src/view/UserDetails.tsx